import { forwardRef, HTMLProps } from 'react'
import { EventCardSkeleton } from '@/entities/event-card-skeleton'

interface EventsLoaderProps extends HTMLProps<HTMLDivElement> {}

export const EventsLoader = forwardRef<HTMLDivElement, EventsLoaderProps>((props, ref) => {
  const { className } = props

  return (
    <>
      {[4, 3, 2, 1].map((_, index) => (
        <EventCardSkeleton className={className} key={index} />
      ))}
    </>
  )
})

EventsLoader.displayName = 'EventsLoader'
